/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';
import { UserGet } from './user.get';

export const UserPatch = {
  id: 'user.patch',
  tag: 'User',
  summary: 'Update a user',
  description: 'Update user details',
  method: 'patch',
  flags: { isAuthorized: true },
  route: () => `/user`,
  request: {
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            email: z.string().email().optional(),
            oldPassword: ZodTypes.UserPassword.optional(),
            newPassword: ZodTypes.UserPassword.optional(),
            firstName: ZodTypes.SanitizedString.optional(),
            middleName: ZodTypes.SanitizedString.nullable().optional(),
            lastName: ZodTypes.SanitizedString.optional(),
            language: ZodTypes.Language.optional(),
            phoneCountryCode: ZodTypes.Country.nullable().optional(),
            phoneNationalNumber: ZodTypes.NumberString.nullable().optional(),
            marketable: z.boolean().optional(),
            address: z
              .strictObject({
                line1: ZodTypes.TrimmedString.min(4).optional(),
                line2: ZodTypes.TrimmedString.min(4).nullable().optional(),
                line3: ZodTypes.TrimmedString.min(4).nullable().optional(),
                postalCode: ZodTypes.TrimmedString.min(4).optional(),
                city: ZodTypes.TrimmedString.min(1).optional(),
                state: ZodTypes.TrimmedString.min(1).nullable().optional(),
                countryCode: ZodTypes.Country.optional(),
              })
              .nullable()
              .optional(),
            notificationSettings: z.array(z.strictObject({ notification: ZodTypes.Notification })).optional(),
            thumbnail: ZodTypes.ThumbnailFormat.optional(),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: UserGet.response['200'].content['application/json'].schema,
        },
      },
    },
  },
} as const satisfies Endpoint;
